import type { FreeFormObject } from '@ctcells/contract'

import tuberack10 from './opentrons_10_tuberack_falcon_4x50ml_6x15ml_conical.json'
import aluminumblock24 from './opentrons_24_aluminumblock_nest_1.5ml_snapcap.json'
import tuberack6 from './opentrons_6_tuberack_falcon_50ml_conical.json'
import tiprack96 from './opentrons_96_tiprack_1000ul.json'

/**
 * **Opentrons 표준 랩웨어 정의 사본 4종**(Apache-2.0 · 출처 `README.md`) — `parameters.loadName` 으로 찾는다.
 *
 * 🔴 **폴백이다.** 도는 작업이 있으면 그 레시피 `payload.labware[]` 에 박힌 정의를 먼저 쓴다 — 레시피가
 *    실제로 장비에 싣는 값이라서다. 이 사본은 작업이 없을 때 데크 판이 비지 않게 하는 자리다.
 * ⚠ 이 패키지(`@ctcells/fixtures`)는 걷어낼 예정이다. 걷을 때 이 폴더는 `@ctcells/ui` 쪽으로 옮긴다 —
 *   데모 데이터가 아니라 표준 정의라 서버 응답이 붙어도 폴백으로 남는다.
 */
export const OPENTRONS_DEFINITIONS: Readonly<Record<string, FreeFormObject>> = Object.fromEntries(
  [tiprack96, tuberack6, tuberack10, aluminumblock24].map((def) => [
    def.parameters.loadName,
    def as FreeFormObject,
  ]),
)
